import { render, staticRenderFns } from "./AllocatedClientList.vue?vue&type=template&id=744dd64c&"
import script from "./AllocatedClientList.vue?vue&type=script&lang=js&"
export * from "./AllocatedClientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports